var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      animation: "spinnerLight__ts 1000ms linear infinite normal forwards"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes spinnerLight__ts{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Release---1.1.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen-Documents-Upload-With-FIles-States",
    transform: "translate(-1155 -711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UploadModal",
    transform: "translate(220 166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(833 540)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spinner-light",
    transform: "translate(103 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.5,
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 9,
    cy: 10,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10A10.002 10.002 0 009 0v2a8 8 0 018 8h2z",
    id: "Path",
    fill: "#FFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLight);
export default __webpack_public_path__ + "static/media/Spinner-Light.e618bb16.svg";
export { ForwardRef as ReactComponent };